<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "财务管理" },
        { name: "稳定基金管理" },
      ],
      menuIndex: '',
      menu: [
        {
          name: "在职",
          path: "/finance/stabilizationFund/table",
        },
        {
          name: "离职",
          path: "/finance/stabilizationFund/table/2",
        },
        {
          name: "冻结",
          path: "/finance/stabilizationFund/table/3",
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
